import { render, staticRenderFns } from "./CreateEmployee.vue?vue&type=template&id=a3b63ef2"
import script from "./CreateEmployee.vue?vue&type=script&lang=js"
export * from "./CreateEmployee.vue?vue&type=script&lang=js"
import style0 from "./CreateEmployee.vue?vue&type=style&index=0&id=a3b63ef2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports